import './SonarUserTooltip.scss';

import { Tooltip } from 'antd';

import React, { PropsWithChildren, ReactNode } from 'react';

export interface SonarUserTooltipProps {
	avatar?: JSX.Element;
	email: string;
	name: ReactNode;
}

export const SonarUserTooltip: React.FC<PropsWithChildren<SonarUserTooltipProps>> = ({
	avatar,
	children,
	email,
	name
}) => {
	const tooltipContent =
		<div className='tooltip-content'>
			{ avatar }
			<div className='tooltip-details'>
				<div>{ name }</div>
				<div>{ email }</div>
			</div>
		</div>;

	return (
		<Tooltip
			classNames={ { root: 'user-tooltip' } }
			mouseEnterDelay={ 0.5 }
			placement='top'
			title={ tooltipContent }>
			{ children }
		</Tooltip>
	);
};
